import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Loader2 } from "lucide-react";

const MSG = "Eliminazione definitiva, non si potrà più recuperare. Scrivi ELIMINA per confermare.";

const chiedi = () => {
  const v = window.prompt(MSG);
  if (v === null) return null;
  if (v.trim() !== "ELIMINA") { toast.error("Conferma non valida: scrivi ELIMINA."); return null; }
  return "ELIMINA";
};

export function EliminaDefBtn({ ambito, id, onDone, testid }) {
  const [busy, setBusy] = useState(false);
  const run = async (e) => {
    e?.stopPropagation();
    const conferma = chiedi();
    if (!conferma) return;
    setBusy(true);
    try { await api.post(`/cestino/${ambito}/${id}/elimina-definitivo`, { conferma }); toast.success("Eliminato definitivamente"); onDone?.(); }
    catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };
  return (
    <button data-testid={testid} onClick={run} disabled={busy}
      className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl bg-red-600 text-white text-xs font-semibold hover:bg-red-700 transition-colors disabled:opacity-50">
      {busy ? <Loader2 size={14} className="animate-spin" /> : <Trash2 size={14} />} Elimina definitivamente
    </button>
  );
}

export function SvuotaCestinoBtn({ ambito, count, onDone }) {
  const [busy, setBusy] = useState(false);
  if (!count) return null;
  const run = async () => {
    const conferma = chiedi();
    if (!conferma) return;
    setBusy(true);
    try { const { data } = await api.post(`/cestino/${ambito}/svuota`, { conferma }); toast.success(`Cestino svuotato: ${data.eliminati} elementi eliminati definitivamente`); onDone?.(); }
    catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };
  return (
    <button data-testid={`svuota-cestino-${ambito}`} onClick={run} disabled={busy}
      className="inline-flex items-center gap-2 px-4 py-2 rounded-xl border-2 border-red-600 text-red-700 bg-white text-sm font-semibold hover:bg-red-600 hover:text-white transition-colors disabled:opacity-50">
      {busy ? <Loader2 size={15} className="animate-spin" /> : <Trash2 size={15} />} Svuota cestino ({count})
    </button>
  );
}
